import { GlassCard, GlassCardContent, GlassCardDescription, GlassCardHeader, GlassCardTitle } from "@/components/ui/glass-card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Palette } from "lucide-react";
import { useTheme, type Theme } from "@/components/theme-provider";
import { useCompactMode } from "@/hooks/useCompactMode";

export function ThemeAppearanceSection() {
  const { theme, setTheme } = useTheme();
  const { compact, setDensity } = useCompactMode();
  return (
    <GlassCard variant="default" hover={false}>
      <GlassCardHeader>
        <GlassCardTitle className="flex items-center gap-2">
          <Palette className="h-5 w-5" />
          Theme and Appearance
        </GlassCardTitle>
        <GlassCardDescription>
          Customize the look and feel of the application
        </GlassCardDescription>
      </GlassCardHeader>
      <GlassCardContent className="space-y-4">
        <div className="space-y-2 max-w-sm">
          <Label htmlFor="theme">Theme</Label>
          <Select value={theme} onValueChange={(v) => setTheme(v as Theme)}>
            <SelectTrigger id="theme">
              <SelectValue placeholder="Select theme" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="light">Light</SelectItem>
              <SelectItem value="dark">Dark</SelectItem>
              <SelectItem value="system">System (follow OS)</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-sm text-muted-foreground">
            Your choice follows you across browsers and devices.
          </p>
        </div>

        <div className="flex items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <Label>Compact Mode</Label>
            <p className="text-sm text-muted-foreground">
              Tighten table rows and card padding to fit more content. Default for new users.
            </p>
          </div>
          <Switch
            checked={compact}
            onCheckedChange={(c) => setDensity(c ? "compact" : "comfortable")}
          />
        </div>
      </GlassCardContent>
    </GlassCard>
  );
}
